<template>
    <div id="RequestList">
        <v-card>
            <v-card-title>
                <h1 style="color: #1976d2">{{ documentTableName }}</h1>
            </v-card-title>
            <v-card-text>
                <v-layout no-gutters class="align-baseline">
                    <v-flex style="max-width: 110px; min-width: 110px">
                        <v-btn style="font-size: 12px" @click="exportToExcel" :loading="exportLoading" :disabled="$parent.loading"> Excel </v-btn>
                        <export-excel name="Excel.xls" ref="excelExportRef" class="d-none" :fields="json_fields" :fetch="FetchData"></export-excel>
                    </v-flex>
                    <v-flex style="max-width: 130px; min-width: 130px">
                        <span style="font-size: 1em">{{ $t('Выберите период') }}</span>
                    </v-flex>
                    <v-flex style="max-width: 150px; min-width: 100px">
                        <v-menu v-model="createdDateFromMenu" :close-on-content-click="false" full-width max-width="290">
                            <template v-slot:activator="{ on }">
                                <v-text-field
                                    locale="ru-RU"
                                    class="date-picker-tf pt-0"
                                    :prefix="$t('с')"
                                    style="font-size: 1em"
                                    :value="formatDateLocal($parent.dateFrom)"
                                    readonly
                                    v-on="on"
                                    :disabled="$parent.loading"
                                    clearable
                                    @click:clear="$parent.dateFrom = null"
                                >
                                    <!-- :placeholder="$t('Выберите дату')" -->
                                </v-text-field>
                            </template>
                            <v-date-picker
                                first-day-of-week="1"
                                v-model="$parent.dateFrom"
                                @change="createdDateFromMenu = false"
                                style="font-size: 1em"
                                :month-format="getMonthFormat"
                                :header-date-format="getHeaderFormat"
                                :weekday-format="getWeekdayFormat"
                            ></v-date-picker>
                        </v-menu>
                    </v-flex>
                    <v-flex style="max-width: 150px; min-width: 100px">
                        <v-menu v-model="createdDateToMenu" :close-on-content-click="false" full-width max-width="290">
                            <template v-slot:activator="{ on }">
                                <v-text-field
                                    locale="ru-RU"
                                    :value="formatDateLocal($parent.dateTo)"
                                    class="date-picker-tf pt-0"
                                    :prefix="$t('по')"
                                    style="font-size: 1em"
                                    readonly
                                    v-on="on"
                                    :disabled="$parent.loading"
                                    clearable
                                    @click:clear="$parent.dateTo = null"
                                >
                                </v-text-field>
                            </template>
                            <v-date-picker
                                locale="ru-RU"
                                first-day-of-week="1"
                                v-model="$parent.dateTo"
                                @change="createdDateToMenu = false"
                                style="font-size: 1em"
                                :month-format="getMonthFormat"
                                :header-date-format="getHeaderFormat"
                                :weekday-format="getWeekdayFormat"
                            >
                            </v-date-picker>
                        </v-menu>
                    </v-flex>
                    <v-flex />
                    <v-flex style="min-width: 10px; padding-right: 10px">
                        <v-select
                            class="pt-0"
                            :placeholder="$t('Выберите РОЭС')"
                            dense
                            append-icon="mdi-chevron-down"
                            :menu-props="{
                                offsetY: true
                            }"
                            multiple
                            style="font-size: 1em"
                            :items="ADLT"
                            ::itemsLoading="divisionsListLoading"
                            item-text="name"
                            item-value="code_name"
                            :disabled="$parent.loading"
                            :item-disabled="() => $parent.loading"
                            v-model="$parent.roesName"
                        ></v-select>
                    </v-flex>
                    <v-flex>
                        <v-select
                            class="pt-0"
                            :placeholder="$t('Выберите тип заявки')"
                            dense
                            append-icon="mdi-chevron-down"
                            :menu-props="{
                                offsetY: true
                            }"
                            multiple
                            style="font-size: 1em"
                            :items="availableProcesses2"
                            ::itemsLoading="processesListLoading2"
                            item-text="name"
                            item-value="id"
                            :disabled="$parent.loading"
                            :item-disabled="() => $parent.loading"
                            v-model="$parent.requestType"
                        ></v-select>
                        <!-- :label="$t('Тип заявки')" -->
                    </v-flex>
                </v-layout>
                <v-data-table
                    :headers="headers"
                    :rows-per-page-items="[5, 10, 15, 100]"
                    :items="documentTableContent"
                    :total-items="$parent.pagination.totalItems"
                    :pagination.sync="$parent.pagination"
                    :loading="documentTableLoading"
                    :expand="false"
                    item-key="id"
                    must-sort
                    flat
                >
                    <template v-slot:items="props">
                        <tr @click="$emit('handleRowClicked', props.item)">
                            <td>{{ props.item.requestNumber }}</td>
                            <td>{{ props.item.roesName }}</td>
                            <td>{{ props.item.accountNumber }}</td>
                            <td>{{ $t(props.item.requestType) }}</td>
                            <td>{{ props.item.author }}</td>
                            <td>{{ props.item.createDateTime | formatDate }}</td>
                            <td>{{ props.item.signedDateTime | formatDate }}</td>
                            <td>
                                <v-btn @click="handePrintRequest(props.item.id)">{{ $t('Печать') }}</v-btn>
                            </td>
                        </tr>
                    </template>
                    <template v-slot:expand="props">
                        <div>
                            <v-btn @click="$emit('handleRowClicked', props.item)">{{ $t('Просмотр') }}</v-btn>
                        </div>
                    </template>
                </v-data-table>
            </v-card-text>
        </v-card>
    </div>
</template>


<script>
import moment from 'moment';
import { mapGetters, mapState, mapActions } from 'vuex';
import { DocumentService } from '../services/document.service';
import i18n from '../i18n';
import translate from '../utility/translate.util';

import Vue from 'vue';
import excel from 'vue-excel-export';
Vue.use(excel);
export default {
    name: 'RequestList',

    data: () => ({
        filterDialog: false,

        createdDateFromMenu: false,
        createdDateToMenu: false,
        signedDateFromMenu: false,
        signedDateToMenu: false,
        filters: {
            //requestType: [],
            author: [],
            createdDateFrom: undefined,
            createdDateTo: undefined,
            signedDateFrom: undefined,
            signedDateTo: undefined
        },
        isMounted: false,
        documentTableContent2: [],
        exportLoading: false
    }),

    props: {
        documentTable: {
            type: Object
        },
        documentTableId: {
            type: String
        },
        documentTableName: {
            type: String
        },
        documentTableContent: {
            type: Array
        },
        documentTableLoading: {
            type: Boolean
        },
        tableOptionsToExport: {
            type: Object
        }
    },

    computed: {
        ...mapState('request', ['requestList']),
        ...mapState('bpm', ['processesListLoading2']),
        ...mapState('bpm', ['divisionsListLoading']),
        ...mapGetters('bpm', ['availableProcesses2']),
        ...mapGetters('bpm', ['availableDivisions']),

        headers() {
            return [
                {
                    text: this.$t('Номер заявки'),
                    value: 'requestNumber'
                },
                { text: this.$t('РОЭС'), value: 'roesName' },
                { text: this.$t('Лицевой счет'), value: 'accountNumber' },
                { text: this.$t('Тип заявки'), value: 'requestType' },
                { text: this.$t('Автор'), value: 'author' },
                { text: this.$t('Дата создания'), value: 'createDateTime' },
                { text: this.$t('Дата подписания'), value: 'signedDateTime' },
                { text: this.$t('Печать'), value: '', sortable: false }
            ];
        },
        ADLT() {
            return translate(this.availableDivisions, 'full', this.$i18n.locale);
        },
        json_fields() {
            let fields = {};
            fields[this.$t('Номер заявки')] = 'requestNumber';
            fields[this.$t('РОЭС')] = 'roesName';
            fields[this.$t('Лицевой счет')] = 'accountNumber';
            //fields[this.$t('Тип заявки')] = 'requestType';
            fields[this.$t('Тип заявки')] = {
                field: 'requestType',
                callback: value => {
                    const temp = this.availableProcesses2.find(t => t.name_Ru === value);
                    const locale = i18n.locale === 'kz' ? 'Kk' : 'Ru';
                    return temp[`name_${locale}`];
                }
            };
            fields[this.$t('Автор')] = 'author';
            fields[this.$t('Дата создания')] = {
                field: 'createDateTime',
                callback: value => {
                    return moment(`${value}`).format('DD.MM.YYYY HH:mm');
                }
            };
            fields[this.$t('Дата подписания')] = {
                field: 'signedDateTime',
                callback: value => {
                    return value ? moment(`${value}`).format('DD.MM.YYYY HH:mm') : `${value}`;
                }
            };
            return fields;
        }
    },
    methods: {
        ...mapActions('bpm', ['intiProcessesList2', 'completeProcess']),
        ...mapActions('bpm', ['initDivisionsList', 'completeProcess']),
        formatDateLocal(date) {
            return date ? moment(String(date)).format('DD.MM.YYYY') : null;
        },
        handePrintRequest(itemId) {
            this.$router.push({ name: 'request-print', params: { request_id: itemId } });
        },
        async exportToExcel() {
            try {
                this.exportLoading = true;

                const response = await DocumentService.getDocumentsTableAll(
                    this.tableOptionsToExport.folderId,
                    this.tableOptionsToExport.status,
                    this.tableOptionsToExport.requestType,
                    this.tableOptionsToExport.roesName,
                    this.tableOptionsToExport.dateFrom,
                    this.tableOptionsToExport.dateTo,
                    this.tableOptionsToExport.page,
                    this.tableOptionsToExport.rowsPerPage,
                    this.tableOptionsToExport.sortBy,
                    this.tableOptionsToExport.descending
                );

                let content = [];
                for (var i in response.content) {
                    response.content[i].data.mainData.id = response.content[i].id;
                    content[i] = response.content[i].data.mainData;
                    content[i].roesName = response.content[i].data.accountsData.roes_name;
                    content[i].accountNumber = response.content[i].data.accountsData.account_number;
                }

                this.documentTableContent2 = content;
                //console.log('Exporting data: ', this.documentTableContent2);

                const el = this.$refs.excelExportRef.$el.click();
            } finally {
                this.exportLoading = false;
            }
        },
        async FetchData() {
            return this.documentTableContent2;
        },
        getMonthFormat(isoDate) {
            moment.locale(this.$i18n.locale === 'kz' ? 'kk-KZ' : 'ru-Ru');
            return moment(isoDate.substr(5), 'M').format('MMMM');
        },
        getHeaderFormat(isoDate) {
            moment.locale(this.$i18n.locale === 'kz' ? 'kk-KZ' : 'ru-Ru');
            const month = isoDate.length > 4 ? moment(isoDate.substr(5), 'M').format('MMMM') : '';
            const res = this.$i18n.locale === 'kz' ? isoDate.substr(0, 4) + ' ж. ' + month : month + ' ' + isoDate.substr(0, 4) + ' г.';
            return res;
        },
        getWeekdayFormat(isoDate) {
            moment.locale(this.$i18n.locale === 'kz' ? 'kk-KZ' : 'ru-Ru');
            return moment(new Date(isoDate)).format('dddd').substr(0, 1);
        }
    },
    mounted() {
        this.$nextTick(() => {
            this.isMounted = true;
        });
        this.$nextTick(() => {
            this.intiProcessesList2();
            this.initDivisionsList();
        });
    }
};
</script>
<style>
.date-label {
    margin-bottom: 5px !important;
    font-size: 18px !important;
    font-weight: 350;
    line-height: 24px !important;
    letter-spacing: normal !important;
    font-family: 'Roboto', sans-serif !important;
}
.date-picker-tf {
    margin-left: 5px;
    margin-right: 5px;
}
.v-text-field input {
    font-size: 0.9em;
}
</style>

